/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBST is TBS plus 0.1% Tween-20 (1 mL per litre).`)
};

const es_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBST es TBS más 0.1% de Tween-20 (1 mL por litro).`)
};

const de_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBST ist TBS plus 0,1 % Tween-20 (1 mL pro Liter).`)
};

const nl_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBST is TBS plus 0,1% Tween-20 (1 mL per liter).`)
};

const fr_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le TBST est du TBS additionné de 0,1 % de Tween-20 (1 mL par litre).`)
};

const it_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il TBST è TBS più 0,1% di Tween-20 (1 mL per litro).`)
};

const pt_br2_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O TBST é o TBS mais 0,1% de Tween-20 (1 mL por litro).`)
};

const pt_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O TBST é TBS mais 0,1% de Tween-20 (1 mL por litro).`)
};

const ja_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBSTはTBSに0.1%のTween-20(1リットルあたり1 mL)を加えたものです。`)
};

const zh_buf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBST 即 TBS 加 0.1% Tween-20（每升 1 mL）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_ex2", locale)
	if (locale === "en") return en_buf_ex2(inputs)
	if (locale === "es") return es_buf_ex2(inputs)
	if (locale === "de") return de_buf_ex2(inputs)
	if (locale === "nl") return nl_buf_ex2(inputs)
	if (locale === "fr") return fr_buf_ex2(inputs)
	if (locale === "it") return it_buf_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_buf_ex2(inputs)
	if (locale === "pt") return pt_buf_ex2(inputs)
	if (locale === "ja") return ja_buf_ex2(inputs)
	return zh_buf_ex2(inputs)
};